const g_devtricker_themeConfig = {
    /**
     * persist: store in local storage the chosen color schema after selected
     * clear: clear the local storage
     * Excepted by 'auto' any other scheme color most be persist: true and clear: false after user chose
     */
    'auto': {
        name: 'auto',
        cssClass: devtricker_getDefaultBrowserColorSchema() + '-mode-dt',
        persist: false,
        clear: true
    },
    'dark': {
        name: 'dark',
        cssClass: 'dark-mode-dt',
        persist: true,
        clear: false
    },
    'light': {
        name: 'light',
        cssClass: 'light-mode-dt',
        persist: true,
        clear: false
    }
};

document.addEventListener('DOMContentLoaded', function () {
    /** Set color scheme on load page */
    devtricker_setColorSchemeAfterLoad();

    /** Listening dropdown color scheme selections */
    document.querySelectorAll('.color-scheme-dropdown').forEach(dropdown => {
        dropdown.querySelectorAll('.dropdown-item').forEach(item => {
            item.addEventListener('click', function () {
                const selectedColor = this.getAttribute('data-param');
                devtricker_dispatchChangeColorSchemeEvent(selectedColor);
            });
        });
    });

    /** Listening User Agent color schema preferences only in browsers with support */
    if (window.matchMedia) {
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', devtricker_setColorSchemeAfterLoad);
    }
});

function devtricker_getDefaultBrowserColorSchema() {
    return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') || 'light';
}


function devtricker_dispatchChangeColorSchemeEvent(colorScheme) {
    const event = new CustomEvent("changeColorSchemeTo", { detail: { colorScheme } });
    document.dispatchEvent(event);
}

function devtricker_setColorSchemeAfterLoad() {

    let colorScheme = devtricker_getUserColorSchemePreference() || 'auto';

    //Only persists if a user has chosen
    g_devtricker_themeConfig[colorScheme].clear = false;
    g_devtricker_themeConfig[colorScheme].persist = false;

    //Reload the auto cssClass after user agent update
    if (colorScheme === 'auto') {
        g_devtricker_themeConfig[colorScheme].cssClass = devtricker_getDefaultBrowserColorSchema() + '-mode-dt';
    }

    devtricker_dispatchChangeColorSchemeEvent(colorScheme);
    setTimeout(devtricker_resetOriginalValues(colorScheme), 500);
}

// Excepted by 'auto' any other scheme color most be persist: true and clear: false after user chose
function devtricker_resetOriginalValues(colorScheme) {
    if (colorScheme === 'auto') {
        g_devtricker_themeConfig[colorScheme].persist = false;
        g_devtricker_themeConfig[colorScheme].clear = true;

    } else {
        g_devtricker_themeConfig[colorScheme].persist = true;
        g_devtricker_themeConfig[colorScheme].clear = false;
    }
}

document.addEventListener("changeColorSchemeTo", function (e) {

    let theme = g_devtricker_themeConfig[e.detail.colorScheme];

    if (!theme) {
        return;
    }

    devtricker_changeHtmlClass(theme.cssClass);
    devtricker_persistPreferences(theme.persist, theme.clear, theme.name);
    devtricker_changeDropdownIcon(theme.cssClass);

});


function devtricker_dom_comment_setLikeIconStyle(commentId, style) {

    const iconElement = document.querySelector(`#li-comment-${commentId} .up-vote-button .icon`);
    if (!iconElement) return;

    iconElement.classList.remove('icon-heart', 'icon-heart-fill');

    const newClass = style === 'fill' ? 'icon-heart-fill' : 'icon-heart';
    iconElement.classList.add(newClass);
}

function devtricker_changeDropdownIcon(colorScheme) {
    const buttons = document.querySelectorAll('.colorThemeButton .icon');

    if (!buttons.length) return;

    buttons.forEach(iconElement => {
        iconElement.classList.remove('icon-circle-half', 'icon-moon', 'icon-sun');

        if (colorScheme === 'dark-mode-dt') {
            iconElement.classList.add('icon-moon');
        }

        if (colorScheme === 'light-mode-dt') {
            iconElement.classList.add('icon-sun');
        }
    });
}

function devtricker_changeHtmlClass(cssClass) {

    const htmlElement = document.documentElement;

    if (!htmlElement.classList.contains(cssClass)) {

        var classes = [...htmlElement.classList];
        classes.forEach(c => {
            if (c.endsWith('-mode-dt')) {
                htmlElement.classList.remove(c);
            }
        });
        htmlElement.classList.add(cssClass);
    }
}

function devtricker_getUserColorSchemePreference() {
    try {
        return devtricker_safelyGetLocalStorage('user-prefers-color-scheme');
    } catch (error) { }
}

function devtricker_persistPreferences(persist, clear, colorSchemeName) {

    if (persist) {
        devtricker_safelySetLocalStorage('user-prefers-color-scheme', colorSchemeName);
    }

    if (clear) {
        devtricker_safelyRemoveLocalStorage('user-prefers-color-scheme');
    }
}